import type { DiceType, Effect, IncrementStatEffect } from "./common.ts";

export function modifyDiceType(
  initial: DiceType,
  effects: IncrementStatEffect<string>[]
) {
  const dice: DiceType[] = ["D4", "D6", "D8", "D10", "D12"];

  const initialIndex = Math.max(
    dice.findIndex((v) => v === initial),
    0
  );

  const index = Math.min(
    effects.reduce((acc, effect) => acc + effect.value, initialIndex),
    dice.length - 1
  );

  // Since we are clamping the value above, the coalscing operator is just here
  // to appease TypeScript.
  return dice[index] ?? "D4";
}

export function getEffectsFor<
  T extends Extract<Effect, { stat: string }>["type"],
  S extends Extract<Effect, { type: T; stat: string }>["stat"]
>(
  effects: Effect[],
  match: { type: T; stat: S; data: { type: { id: string } } }
) {
  return effects.filter(
    (effect): effect is Extract<Effect, { type: T; stat: S }> => {
      return (
        effect.type === match.type &&
        effect.stat === match.stat &&
        (!effect.when || effect.when.type === match.data.type.id)
      );
    }
  );
}
